import { classes } from "lib/actions/util";
import { categorizeAsset } from "lib/actions/assets/categorizeAsset";
import { AssetCategory } from "lib/types/assets/AssetCategory";
import { AssetModel } from "lib/types/assets/AssetModel";
import React from "react";
import GisSvg from "components/icons/24/AssetTypeIcons/asset_type-gis.svg";
import ImageSvg from "components/icons/24/AssetTypeIcons/asset_type-image.svg";
import ModelSvg from "components/icons/24/AssetTypeIcons/asset_type-model.svg";
import ZipSvg from "components/icons/24/AssetTypeIcons/asset_type-zip.svg";
import PdfSvg from "components/icons/24/AssetTypeIcons/asset_type-pdf.svg";
import PointcloudSvg from "components/icons/24/AssetTypeIcons/asset_type-pointcloud.svg";
import ScansetSvg from "components/icons/24/AssetTypeIcons/asset_type-scanset.svg";
import RasterSvg from "components/icons/24/AssetTypeIcons/asset_type-raster.svg";
import CadSvg from "components/icons/24/AssetTypeIcons/asset_type-cad.svg";
import UncategorisedSvg from "components/icons/24/AssetTypeIcons/asset_type-uncategorised.svg";
import AutodeskSvg from "components/icons/24/AssetTypeIcons/asset_type-autodesk.svg";

/** The colour each file type's icon takes, as a text colour class */
const assetCategoryColours: Partial<Record<AssetCategory, string>> = {
  [AssetCategory.bim]: "text-indigo-500",
  [AssetCategory.pointcloud]: "text-purple-500",
  [AssetCategory.scanset]: "text-sky-500",
  [AssetCategory.gis]: "text-green-500",
  [AssetCategory.raster]: "text-amber-500",
  [AssetCategory.pdf]: "text-red-500",
  [AssetCategory.cad]: "text-pink-500",
  [AssetCategory.image]: "text-sky-500",
};

const assetCategoryIcons: Partial<
  Record<AssetCategory, React.FunctionComponent<{ className?: string }>>
> = {
  [AssetCategory.bim]: ModelSvg,
  [AssetCategory.pointcloud]: PointcloudSvg,
  [AssetCategory.scanset]: ScansetSvg,
  [AssetCategory.gis]: GisSvg,
  [AssetCategory.raster]: RasterSvg,
  [AssetCategory.pdf]: PdfSvg,
  [AssetCategory.cad]: CadSvg,
  [AssetCategory.image]: ImageSvg,
  [AssetCategory.zip]: ZipSvg,
  [AssetCategory.autodesk]: AutodeskSvg,
};

/**
 * The text colour class for a file type's icon, so other icons shown for the
 * same asset can take its colour. File types with a plain icon have none.
 */
export function getAssetTypeColourClass(
  type?: AssetModel["type"],
  ext?: string,
): string | undefined {
  return assetCategoryColours[categorizeAsset(type, ext?.toLowerCase())];
}

const AssetTypeIcon = ({
  type,
  ext,
  category,
  width = "w-6",
}: {
  type?: AssetModel["type"];
  ext?: string;
  category?: AssetCategory;
  width?: string;
}) => {
  const className = classes("aspect-square", width);
  const assetTypeIcon = category ?? categorizeAsset(type, ext?.toLowerCase());
  const Icon = assetCategoryIcons[assetTypeIcon] ?? UncategorisedSvg;

  return (
    <Icon className={classes(className, assetCategoryColours[assetTypeIcon])} />
  );
};

export default AssetTypeIcon;
